<ion-header class="ion-no-border app-inner-padding">
	<ion-grid class="ion-no-padding">
		<ion-row class="ion-no-padding">
			<ion-col size="6">
				<ion-title size="small" class="ion-no-padding">{{ controlLabel }}</ion-title>
			</ion-col>
			<ion-col size="6">
				<ion-buttons>
					<ion-button class="ion-no-padding" (click)="close()">
						<ion-icon class="icon-Close"></ion-icon>
					</ion-button>
				</ion-buttons>
			</ion-col>
		</ion-row>
		<ion-row class="ion-padding"></ion-row>
		<ion-row class="ion-no-padding">
			<ion-col size="12" class="search-wrap">
				<ion-searchbar
					class="ion-no-padding"
					clearIcon="close-sharp"
					placeholder=""
					appDebounceKeyUpDirective
					[debounce]="300"
					(ionChange)="onSearchChanged($event)"
				></ion-searchbar>
			</ion-col>
		</ion-row>
	</ion-grid>
</ion-header>
<ion-content class="inner-content app-inner-padding">
	<ion-list lines="none" class="ion-no-padding" *ngIf="displayedOptions.length > 0; else noRefTableData">
		<ion-item class="ion-no-padding leave-empty" (click)="onItemSelected(null)" *ngIf="selectedItemId">
			{{ 'dropdown.leaveEmpty' | translate }}
		</ion-item>
		<ion-item
			*ngFor="let item of displayedOptions"
			(click)="onItemSelected(item)"
			[ngClass]="item.isSelected ? 'selected' : ''"
			class="ion-no-padding"
		>
			<ion-grid class="ion-no-padding">
				<ion-row>
					<ion-col size="12">
						<ion-label>{{ item.value }}</ion-label>
						<ion-icon class="icon-Save"></ion-icon>
					</ion-col>
				</ion-row>
				<ion-row>
					<ion-col size="12">
						<ion-label *ngIf="item.displayBoth; else emptyDesc">{{ item.description }}</ion-label>
						<ng-template #emptyDesc><ion-label></ion-label></ng-template>
					</ion-col>
				</ion-row>
			</ion-grid>
		</ion-item>
	</ion-list>

	<ng-template #noRefTableData>
		<ion-note>{{ 'dropdown.noRecords' | translate }}</ion-note>
	</ng-template>

	<ion-infinite-scroll threshold="100px" (ionInfinite)="displayMoreEntries($event)">
		<ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="{{ 'entity.loadMoreEntries' | translate }}">
		</ion-infinite-scroll-content>
	</ion-infinite-scroll>
</ion-content>
<ion-footer class="ion-no-border"></ion-footer>
